(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-rail-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-rail')) {
    class GmRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gm-rail__track');
        this.prev = this.querySelector('[data-gm-prev]');
        this.next = this.querySelector('[data-gm-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.prev.hidden = false;
        this.next.hidden = false;
        this.prev.addEventListener('click', () => this.#step(-1));
        this.next.addEventListener('click', () => this.#step(1));
        this.track.addEventListener('scroll', () => this.#sync(), { passive: true });
        new ResizeObserver(() => this.#sync()).observe(this.track);
        this.#sync();
      }

      #step(direction) {
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      }

      #sync() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.toggleAttribute('data-static', max <= 0);   // everything fits: no arrows needed
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('gm-rail', GmRail);
  }
  } catch(e) { console.error(e); }
})();

})();
